/* Copyright (c) 2020-present CloudIO Inc */

import type { Platform } from 'componentregistry/platform/Platform';
import { getActualUrl } from 'config/config';
import React from 'react';
import * as ReactDOMClient from 'react-dom/client';
import '@fontsource/roboto';
import './App.css';
import IndexApp from './IndexApp';
import { config } from './platform/UpdateNotifier';
import { register } from './serviceWorkerRegistration';
import './wavedots.css';

async function onInit(platform: Platform): Promise<void> {
  const init = (await import(/* webpackChunkName: "init" */ './init/init'))
    .default;
  init(platform);
}

// eslint-disable-next-line no-restricted-globals
if (self && top && self !== top) {
  // XFSv2: prevent embedding in an iframe
  // eslint-disable-next-line no-restricted-globals
  top.location = self.location;
} else {
  const root = document.getElementById('root') as HTMLDivElement;
  if (root) {
    const a = ReactDOMClient.createRoot(root);
    a.render(
      /* By default, emotion injects its style after JSS, this breaks the computed styles. 
    In order to get the correct CSS injection order until all the components are migrated,
    we need to wrap the root of our application with StylesProvider w/ injectFirst */
      <IndexApp onInit={onInit} />,
    );

    // If you want your app to work offline and load faster, you can change
    // unregister() to register() below. Note this comes with some pitfalls.
    // Learn more about service workers: https://cra.link/PWA
    const url = getActualUrl();
    if (
      process.env.NODE_ENV === 'production' &&
      url !== 'http://localhost:3000/' &&
      url !== 'http://localhost:3003/' // CI runs
    ) {
      register(config);
    }
  }
}
